import { axios, getConfigs, IRequestConfig, PaginatedQuery } from './api'
import { StockDto } from './dtos'
import { PaginatedDto } from './extendedType'

export class StockService {
  private static readonly endpoint = 'stock'

  static getAll(
    query: PaginatedQuery,
  ): Promise<PaginatedDto<StockDto>> {
    return new Promise((resolve, reject) => {
      const configs: IRequestConfig = getConfigs(
        'get',
        'application/json',
        this.endpoint,
        { baseURL: process.env.REACT_APP_RADIOPHARMACY_API_URL },
      )
      configs.params = query
      axios(configs, resolve, reject)
    })
  }
}
